import { ARENA, SPAWN_POINTS } from "../constants/gameConstants.js";
import { ARENA_OBSTACLES, type ArenaObstacle } from "./arenaObstacles.js";

export type { ArenaObstacle };

export interface ArenaLayout {
  /** Full side length of the square arena (metres). */
  size: number;
  /** Rendered wall height (metres). */
  wallHeight: number;
  /** Rendered wall thickness (metres). */
  wallThickness: number;
  /** Obstacles present in this arena. */
  obstacles: ArenaObstacle[];
  /** Named spawn positions for players entering the arena. */
  spawnPoints: ReadonlyArray<{ x: number; z: number; rot: number }>;
}

/** Default layout — matches the hand-crafted 240 m square arena exactly. */
export const DEFAULT_ARENA_LAYOUT: ArenaLayout = {
  size:          ARENA.size,
  wallHeight:    ARENA.wallHeight,
  wallThickness: ARENA.wallThickness,
  obstacles:     ARENA_OBSTACLES,
  spawnPoints:   SPAWN_POINTS,
};
